import { put, takeLatest } from "redux-saga/effects";
import { createErrorAction } from '../reducers/errorSlice';
import { 
    getAllSettingsSuccess, 
    getSettingsByCategorySuccess,
    getSettingByKeySuccess,
    createSettingSuccess,
    updateSettingSuccess,
} from "../reducers/settingSlice";
import { axiosInstance } from "../../config/axios";
import { apiEndpoints } from "../../utils/api-endpoints";
import { getAllSettingsFailed, getSettingsByCategoryFailed, getSettingByKeyFailed, createSettingFailed, updateSettingFailed } from "../reducers/settingSlice";
import { getErrorMessage } from "../../utils/helper.utils";

function* getAllSettings(): any {
    try {
        const response = yield axiosInstance.get(apiEndpoints.setting.all);
        yield put(getAllSettingsSuccess(response.data));
    } catch (error) {
        yield put(getAllSettingsFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'setting/getAllSettings'));
    }
}

function* getSettingsByCategory(action: any): any {
    try {
        const response = yield axiosInstance.get(apiEndpoints.setting.byCategory(action.payload));
        yield put(getSettingsByCategorySuccess(response.data));
    } catch (error) {
        yield put(getSettingsByCategoryFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'setting/getSettingsByCategory'));
    }
}

function* getSettingByKey(action: any): any {
    try {
        const response = yield axiosInstance.get(apiEndpoints.setting.byKey(action.payload));
        yield put(getSettingByKeySuccess(response.data));
    } catch (error) {
        yield put(getSettingByKeyFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'setting/getSettingByKey'));
    }
}

function* createSetting(action: any): any {
    try {
        const response = yield axiosInstance.post(apiEndpoints.setting.create, action.payload);
        yield put(createSettingSuccess(response.data));
    } catch (error) {
        yield put(createSettingFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'setting/createSetting'));
    }
}

function* updateSetting(action: any): any {
    try {
        const { key, value } = action.payload;
        const response = yield axiosInstance.put(apiEndpoints.setting.update(key), { value });
        yield put(updateSettingSuccess(response.data));
    } catch (error) {
        yield put(updateSettingFailed(getErrorMessage(error)));
        yield put(createErrorAction(error, 'setting/updateSetting'));
    }
}

export function* watchSettingSaga() {
    yield takeLatest('setting/getAllSettings', getAllSettings);
    yield takeLatest('setting/getSettingsByCategory', getSettingsByCategory);
    yield takeLatest('setting/getSettingByKey', getSettingByKey);
    yield takeLatest('setting/createSetting', createSetting);
    yield takeLatest('setting/updateSetting', updateSetting);
} 